module.exports = __webpack_public_path__ + "img/globe_logo.0813dee6.png";